import { z } from 'zod';

import { mongoIdSchema } from './shared';

export enum ActionTaskStatus {
  Pending = 'pending',
  Done = 'done',
}

export enum ActionTaskKind {
  Create = 'create',
  Refresh = 'refresh',
}

export const actionTaskCreateSchema = z.object({
  brandId: z.string(),
  actionPlanId: z.string(),
  keywordId: z.string().nullish(),

  contentId: z.string().nullish(),
  status: z.nativeEnum(ActionTaskStatus),
  kind: z.nativeEnum(ActionTaskKind),
  isGenerated: z.boolean(),

  traffic: z.number(),
  leads: z.number(),

  keyword: z.string(),
  url: z.string().nullish(),
  priority: z.number(),

  statusChangeDate: z.number(),
});
export type ActionTaskCreate = z.infer<typeof actionTaskCreateSchema>;

export const actionTaskSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(actionTaskCreateSchema);

export type ActionTask = z.infer<typeof actionTaskSchema>;
